/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, inject } from '@angular/core';
import { TabElementContent } from 'admin-drivers/src/app/common/components/detail-tab-item/models/TabElement';
import { DetailTabItemComponent } from 'admin-drivers/src/app/common/components/detail-tab-item/detail-tab-item.component';
import { TravelDetailsService } from '../../../services/travel-details.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Travel } from 'admin-drivers/src/app/common/models/Travel';

@Component({
  selector: 't-llevo-details-client-section',
  standalone: true,
  imports: [DetailTabItemComponent],
  template: `
    <div class="row p-3">
      <t-llevo-detail-tab-item
        class="col-6"
        contentClasses="h-100 w-100 d-block text-dark"
        rowClasses="py-1"
        [data]="tabItems"
      ></t-llevo-detail-tab-item>
    </div>
  `
})
export class DetailsClientSectionComponent {
  protected data: Travel | null = null
  protected tabItems: TabElementContent[] = []

  private destroyRef = inject(DestroyRef)

  constructor(private travelDetailsSrv: TravelDetailsService){
    this.travelDetailsSrv.selectedTravel$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.data = data
      this.assignTabItems()
    })
  }

  private assignTabItems(){
    if(this.data){
      this.tabItems = [
        {
          name: 'Nombre',
          value: `${this.data.client.firstname} ${this.data.client.lastname}`
        },
        {
          name: 'Email',
          value: this.data.client.email
        },
        {
          name: 'Teléfono',
          value: this.data.client.phone
        },
      ]
    }
    else{
      this.tabItems = []
    }
  }
}
